module.exports = __webpack_public_path__ + "media/images/home-header-93635d357cb588995c38f89345abc21d.jpg";